<template>
  <div
    :style="`
      z-index: 9;
      position: sticky;
      top: ${focusModeToolbarTop};
      width: 100%;
    `"
  >
    <v-card
      ref="facets-toolbar"
      color="rgba(255, 255, 255, 0.8)"
    >
      <v-toolbar
        flat
        color="transparent"
      >
        <section
          v-if="!$vuetify.breakpoint.mdAndDown && appliedFilters.length"
          class="
            d-flex align-center
            px-0
          "
          style="height: 100%; gap: 16px;"
        >
          <p class="my-0">Mes critères:</p>

          <section
            class="d-flex align-center"
            style="height: 100%; gap: 16px;"
          >
            <div
              class="
                persistent-scrollbar
                d-flex align-center overflow-auto
              "
              :style="`height: 100%; max-width: 750px; gap: 16px;`"
            >
              <template v-for="(appliedFilter, appliedFilterIndex) in appliedFilters">
                <v-btn
                  v-if="findFilterConfigByComponent(appliedFilter.attribute)?.component === 'Date'"
                  :key="appliedFilterIndex"
                  elevation="0"
                  @click="removeFilterAndSearch({ attribute: appliedFilter.attribute, value: null })"
                >
                  <template
                    v-for="(value, valueIndex) in appliedFilter.values"
                  >
                    <div :key="valueIndex">
                      <DateContent
                        :item="{ [appliedFilter.attribute]: value }"
                        :header="{ value: appliedFilter.attribute }"
                      />
                      <span v-if="valueIndex === 0" class="ml-1">/</span>
                    </div>
                  </template>
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
                <v-btn
                  v-for="(value, valueIndex) in appliedFilter.values"
                  v-else
                  :key="`${appliedFilterIndex}-${valueIndex}`"
                  elevation="0"
                  @click="removeFilterAndSearch({ attribute: appliedFilter.attribute, value: value })"
                >
                  {{ config.references?.[value] || value }}
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
            </div>

            <v-btn
              text
              class="overline text-decoration-underline"
              @click="clearFiltersAndSearch"
            >
              Tout effacer
            </v-btn>
          </section>
        </section>

        <v-spacer
          v-if="!hasDefaultSort"
        />

        <v-btn
          v-if="$vuetify.breakpoint.mdAndDown"
          class="px-0"
          text
        >
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn
                class="d-flex"
                style="gap: 16px;"
                text
                v-on="on"
                @click="showFacetsDialog = true"
              >
                Filtres ({{ getActiveFiltersCount }})
                <v-icon small>mdi-filter</v-icon>
              </v-btn>
            </template>
            <span>Afficher les filtres</span>
          </v-tooltip>
        </v-btn>

        <v-spacer />
        <v-btn
          v-if="hasDefaultSort"
          class="px-0"
          text
        >
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn
                class="d-flex"
                style="gap: 16px;"
                text
                v-on="on"
                @click="setSort([{ lastUpdateTime: { order: getSortValueByKey('lastUpdateTime')?.order === 'desc' ? 'asc' : 'desc'} }])"
              >
                Trier par défault
                <v-icon small>{{ getSortValueByKey('lastUpdateTime')?.order === 'desc' ? 'mdi-arrow-up' : 'mdi-arrow-down' }}</v-icon>
              </v-btn>
            </template>
            <span>Trier par heure de dernière mise à jour</span>
          </v-tooltip>
        </v-btn>
        <section
          class="d-flex"
          style="gap: 16px;"
        >
        </section>
      </v-toolbar>
      <v-progress-linear
        v-if="loading.form || $store.state.loading"
        indeterminate
        color="primary"
      />
    </v-card>

    <v-dialog
      v-model="showFacetsDialog"
      hide-overlay
      fullscreen
      transition="dialog-top-transition"
    >
      <v-card
        class="d-flex flex-column"
      >
        <v-toolbar
          height="64"
          max-height="64"
          dark
          color="main"
          style="position: sticky; top: 0; z-index: 1000;"
          rounded="0"
        >
          <v-btn icon dark @click="showFacetsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            class="
              d-flex justify-space-between align-center
              flex-grow-1
            "
          >
            Filtres ({{ getActiveFiltersCount }})
            <v-spacer />
            <v-btn
              text
              class="overline text-decoration-underline"
              @click="clearFiltersAndSearch"
            >
              Tout effacer
            </v-btn>
          </v-toolbar-title>
        </v-toolbar>
        <v-card
          elevation="0"
          color="transparent"
          class="flex-grow-1 d-flex flex-column justify-space-between"
        >
          <v-card-text class="px-0">
            <Facets :filters-config="getFiltersConfig" />
          </v-card-text>
          <v-card-actions
            class="pa-0"
            style="position: sticky; bottom: 0; z-index: 1000;"
          >
            <v-btn
              color="primary"
              class="col-12"
              large
              :rounded="false"
              style="border-radius: 0;"
              @click="showFacetsDialog = false"
            >
              <v-icon>mdi-close</v-icon>
              Fermer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import DateContent from '@/components/dataTable/components/DateContent.vue';
import Facets from '@/components/Facets.vue';

export default {
  name: 'FacetsToolbar',
  components: { DateContent, Facets },
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Object,
      default: () => ({})
    },
    focusModeToolbarTop: {
      type: String,
      default: () => '64px'
    },
    hasDefaultSort: {
      type: Boolean,
      default: true
    }
  },
  data () { return { showFacetsDialog: false }; },
  computed: {
    ...mapState(['appliedFilters']),
    ...mapGetters(['getSortValueByKey', 'getFiltersConfig', 'getActiveFiltersCount'])
  },
  methods: {
    ...mapActions(['removeFilterAndSearch', 'clearFiltersAndSearch', 'setSort']),
    findFilterConfigByComponent (attribute) {
      return this.config.filters.find(facet => facet.attribute === attribute);
    }
  }
};
</script>
